import { useState } from 'react';

let globalId = 0;

export default function useNotification() {
  const [notifications, setNotifications] = useState([]);

  function addNotification(message, type = 'info', duration = 4000) {
    const id = ++globalId;
    const notification = { id, message, type, duration };
    setNotifications(prev => [...prev, notification]);
    if (duration > 0) {
      setTimeout(() => {
        setNotifications(prev => prev.filter(n => n.id !== id));
      }, duration);
    }
    return id;
  }

  function removeNotification(id) {
    setNotifications(prev => prev.filter(n => n.id !== id));
  }

  function success(message, duration) { return addNotification(message, 'success', duration); }
  function error(message, duration) { return addNotification(message, 'error', duration || 6000); }
  function warning(message, duration) { return addNotification(message, 'warning', duration); }
  function info(message, duration) { return addNotification(message, 'info', duration); }
  function loading(message) { return addNotification(message, 'loading', 0); }

  return { notifications, addNotification, removeNotification, success, error, warning, info, loading };
}
